module.exports = __webpack_public_path__ + "img/Character_Other_Thumb.fdfef6c8.png";